import { Link } from "@quintype/components";
import React from "react";
import "./join-dh-channel.m.css";

function JoinDHChannel() {
  return (
    <div styleName="join-dh-wrapper">
      <Link href="https://www.whatsapp.com/channel/0029Va4ifN6AYlULZASc7V3S" styleName="join-dh-button" target="_blank">
        <img src="/icons/joindhwhatsapp.png" />
        JOIN US
      </Link>
    </div>
  );
}

export default JoinDHChannel;
